import create from 'zustand';
export const useStore = create((set) => ({
    data: {},
    setBlockData: (id, dataOrFn) => set(({ data: prevData }) => ({
        data: Object.assign(Object.assign({}, prevData), { [id]: typeof dataOrFn === 'function' ? dataOrFn(prevData) : dataOrFn }),
    })),
    setData: (dataOrFn) => set(({ data: prevData }) => ({
        data: typeof dataOrFn === 'function' ? dataOrFn(prevData) : dataOrFn,
    })),
}));
//# sourceMappingURL=store.js.map